module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primærlogo_sentrert_logo_neg.8519049f.png";